<template>
  <div class="p-config-nominated-keyword">
    <div class="c-fieldset">
      <p class="c-fieldset__header">
        <span class="c-fieldset__title">指名キーワードを登録する</span>
      </p>
      <div class="c-fieldset__content c-alertPos">
        <Input
          name="keyword"
          v-model="params.keyword"
          placeholder="（例）株式会社PLAN-B"
          :class="{
            alert: isEdited.keyword && error.keyword
          }"
          @focusout="focusout"
        />
        <Alert v-if="isEdited.keyword && error.keyword">
          {{ error.keyword }}
        </Alert>
        <Alert v-else-if="errorResponse">
          {{ errorResponse }}
        </Alert>
      </div>
      <div class="c-fieldset__btn">
        <Button
          variant="main"
          size="w240"
          fsize="f16"
          :disabled="isLoading || isError || isProcessing"
          :class="{ 'is-loading': isProcessing }"
          @click="submit"
        >
          登録する
        </Button>
      </div>
    </div>
    <Note>
      <template slot="title">
        指名キーワードに関する注意点
      </template>
      <div class="c-text--free">
        <p>
          指名キーワードを設定すると、指名キーワードとそれ以外のキーワードの流入数の割合を確認できます。<br />指名キーワードは「フレーズ一致」で該当するかを判定します。キーワード全体への完全一致や部分一致ではなく、スペースで区切られた単語に対して完全一致での判定をしています。
        </p>
        <p>
          指名キーワードが「株式会社PLAN-B」の場合…<br />指名キーワードに含まれるもの:
          「株式会社PLAN-B」「株式会社PLAN-B SEO」「マーケティング
          株式会社PLAN-B」<br />指名キーワードに含まれないもの:
          「SEO」「webライティング」「マーケティング 大阪」
        </p>
      </div>
    </Note>
  </div>
</template>

<script>
import Alert from '@/components/Alert';
import Button from '@/components/Button';
import Input from '@/components/Input';
import Note from '@/components/Note';
import apiProjects from '@/api/projects';
import utils from '@/utils';
import Validation from '@/validation';

export default {
  props: {
    items: {
      type: Array,
      required: true
    },
    project: {
      type: Object,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    }
  },

  components: {
    Alert,
    Button,
    Input,
    Note
  },

  data() {
    return {
      error: {
        keyword: ''
      },
      errorResponse: '',
      params: {
        keyword: ''
      },
      isEdited: {
        keyword: false
      },
      isError: false,
      isProcessing: false
    };
  },

  computed: {
    keywordNames() {
      return this.items.map(item => item.keyword);
    }
  },

  watch: {
    error: {
      handler() {
        this.checkError();
      },
      deep: true
    },
    keywordNames: {
      handler() {
        this.validate();
      }
    },
    params: {
      handler() {
        // 何か入力したらサーバーからのエラーメッセージを消す
        this.errorResponse = '';
      },
      deep: true
    },
    'params.keyword': {
      handler() {
        this.validate();
      },
      immediate: true
    }
  },

  methods: {
    checkError() {
      this.isError = utils.checkError(this.error);
    },

    focusout() {
      this.params.keyword = this.$options.filters.normalizeAllSpaces(
        this.params.keyword
      );
    },

    getUsages() {
      const params = {
        items: 'nominated-keywords'
      };
      return apiProjects.usages.get(params, this.auth.idToken, this.project.id);
    },

    submit() {
      if (this.isError || this.isProcessing) {
        return;
      }
      this.isProcessing = true;

      // 利用量を取得
      this.getUsages()
        .then(response => {
          const usages = response.data.items[0];
          const error = utils.getErrorUsages({
            usages: usages,
            target: 'キーワード'
          });
          if (error.message) {
            this.errorResponse = error.message;
            this.isProcessing = false;
            return;
          }
          const params = {
            keyword: this.params.keyword
          };
          apiProjects.nominatedKeywords
            .post(params, this.auth.idToken, this.project.id)
            .then(response => {
              this.params.keyword = '';
              this.isProcessing = false;
              this.$emit('add');
            })
            .catch(error => {
              if (error.response.data) {
                this.errorResponse = error.response.data.errors[0].userMessage;
              }
              this.isProcessing = false;
            });
        })
        .catch(error => {
          if (error.response.data) {
            this.errorResponse = error.response.data.errors[0].userMessage;
          }
          this.isProcessing = false;
        });
    },

    validate() {
      const keyword = this.$options.filters.normalizeAllSpaces(
        this.params.keyword.trim()
      );
      this.error.keyword = new Validation()
        .input()
        .notRegistered(this.keywordNames, 'すでに登録されているキーワードです')
        .test(keyword);
      this.isEdited.keyword = keyword ? true : false;
    }
  }
};
</script>
